import React from 'react'
import { Spin } from 'antd'
import { inject, observer } from 'mobx-react'
import { LoadingOutlined } from '@ant-design/icons'

const SpinnerInlineComponent = props => {
  const {
    loadingAnimationStore,
    sizeSpin,
    isLoading,
    alignItems,
    tip,
    noBackground,
    style,
  } = props

  const { showSpinInline } = loadingAnimationStore

  const styleSpinWrapper = {
    textAlign: 'center',
    background: noBackground ? 'unset' : 'rgba(44, 101, 172, 0.3)',
    position: 'absolute',
    zIndex: 29,
    inset: 0,
    display: showSpinInline || isLoading ? 'flex' : 'none',
    justifyContent: 'center',
    alignItems: alignItems || 'center',
    paddingTop: alignItems ? 100 : 0,
    ...style,
  }
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />
  return (
    <div style={{ ...styleSpinWrapper }}>
      <Spin
        size={sizeSpin || 'middle'}
        tip={tip || 'Đang tải...'}
        indicator={antIcon}
      />
    </div>
  )
}

SpinnerInlineComponent.propTypes = {}

export default inject('loadingAnimationStore')(observer(SpinnerInlineComponent))
